import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../../core/state';
import { Subscription } from 'rxjs';
import { TenantService, TenantInfo } from '../../services/tenant.service';

@Component({
  selector: 'black-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  standalone: false,
  host: {
    ngSkipHydration: 'true',
  },
})
export class FooterComponent implements OnInit, OnDestroy {
  private store = inject<Store<State>>(Store);
  public tenantService = inject(TenantService);
  private subscription = new Subscription();

  isHidden = false;
  isAppMode = false;
  currentTenant: TenantInfo | null = null;

  get tenantLogoUrl(): string | undefined {
    return this.currentTenant?.settings?.branding?.logo || undefined;
  }

  get isDefaultTenant(): boolean {
    return this.tenantService.isDefaultTenant();
  }

  ngOnInit(): void {
    this.subscription.add(
      this.tenantService.currentTenant$.subscribe((tenant) => {
        this.currentTenant = tenant;
      })
    );

    this.subscription.add(
      this.tenantService.appMode$.subscribe((appMode) => {
        this.isAppMode = appMode;
      })
    );

    this.subscription.add(
      this.store
        .select((state) => state.config.hideFooter)
        .subscribe((hideFooter) => {
          this.isHidden = hideFooter;
        })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
